/**
 * Elite Fade Designs - App Configuration
 *
 * Centralized config that reads from Vite environment variables.
 * Define these in .env.local (gitignored) or .env.development, etc.
 *
 * Required env vars:
 *   VITE_API_URL                 - Base API URL (e.g. https://xyz.execute-api.us-east-1.amazonaws.com/dev)
 *   VITE_COGNITO_USER_POOL_ID    - Admin pool (e.g. us-east-1_wist8a6VG)
 *   VITE_COGNITO_CLIENT_ID       - Admin client
 *   VITE_COGNITO_CUSTOMER_POOL_ID    - Customer pool (e.g. us-east-1_OP6xx8Jbc)
 *   VITE_COGNITO_CUSTOMER_CLIENT_ID  - Customer client
 *   VITE_AWS_REGION              - e.g. us-east-1
 */
const env = import.meta.env || {};

export const config = {
  apiUrl: env.VITE_API_URL || 'https://jvzsp7nm83.execute-api.us-east-1.amazonaws.com/dev',
  cognito: {
    // Admin pool (Admin / Staff / Dispatcher)
    userPoolId: env.VITE_COGNITO_USER_POOL_ID || 'us-east-1_wist8a6VG',
    clientId:   env.VITE_COGNITO_CLIENT_ID    || '67dsthtsn9vidgfm5et4ub0q39',
    region:     env.VITE_AWS_REGION           || 'us-east-1',

    // Customer pool (public sign-up)
    customer: {
      userPoolId: env.VITE_COGNITO_CUSTOMER_POOL_ID || 'us-east-1_OP6xx8Jbc',
      clientId:   env.VITE_COGNITO_CUSTOMER_CLIENT_ID || '4rb1j6kmblpdbosp1b0lb68vfl',
      region:     env.VITE_AWS_REGION || 'us-east-1',
    },
  },
  env: env.MODE || 'development',
  isDev: (env.MODE || 'development') === 'development',
};

if (config.isDev) {
  console.info('[Elite Fade] Config loaded', {
    apiUrl: config.apiUrl,
    env: config.env,
  });
}
